<template>
  <div :class="fitScreen1366 && $store.getters.isLowerThenScreen1366 ? 'screen1366' : ''" style="display: flex;justify-content: flex-start;margin: 0px 3px;flex-wrap: wrap">
    <div v-show="isSumVisible">{{ $t('CargoMsg.Cargo_AllAmountP')+numAll }}</div>
    <div v-show="isSumVisible" style="margin: 0px 10px;">{{ $t('CargoMsg.Cargo_SelectedItems',['['+numSelected+']']) }}</div>
    <span style="font-size: 12px;">{{ title }}</span>
    <div v-for="(item,index) in dynamicChildren" :key="index" style="padding-right: 2px;font-size: 12px;">
      <span v-if="item.type==='label'">{{ item.text }}</span>
      <div v-if="item.type==='input'" class="input-div" :style="{width:(item.text.length*5+25)+'px'}" v-text="item.text" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AmountSumMaster',
  props: {
    isInvoice: { type: Boolean, default: false },
    datafield: { type: String },
    title: { type: String, default: () => { return this.$t('CargoMsg.Cargo_AmountToP') } },
    arDataField: { type: String, default: '' },
    onSelect: { type: Boolean, default: true },
    hasMutiCurrency: { type: Boolean, default: false },
    isSimpleSum: { type: Boolean, default: false }, // //是否只是简单的将列进行合计
    isSumVisible: { type: Boolean, default: true },
    isAr: { type: Boolean, default: false },
    dataProvider: { type: Array, default: () => [] },
    fitScreen1366: { type: Boolean, default: false } // 是否适配分辨率宽度低于1366的样式
  },
  data() {
    return {
      data: [],
      currencyInUse: ['RMB', 'USD', 'HKD', 'EUR', 'GBP', 'JPY'],
      currencyUsed: [],
      dynamicChildren: [],
      numAll: 0,
      numSelected: 0,
      useCurrencyORI: false // 是否使用原币种
    }
  },
  watch: {
    dataProvider(newVal) {
      this.setDataProvider(newVal)
    }
  },
  created() {
    this.onPreinitialize()
    this.setDataProvider(this.dataProvider)
  },
  methods: {
    onPreinitialize() {
      this.currencyUsed = []
      for (const c of this.currencyInUse) {
        this.currencyUsed.push({ currency: c, sum: 0 })
      }
    },
    handleSelectedField(value, event) {
      const selectedUuids = event.api.getSelectedRows().map(item => item.UUID)
      value = value.map(item => {
        if (selectedUuids.includes(item.UUID)) {
          item.isSelect = 1
        } else {
          item.isSelect = 0
        }
      })
    },
    handleAllNum(event) {
      if (event) {
        event.api.forEachNode(node => {
          if (node.displayed) {
            this.numAll += 1
          }
        })
      }
    },
    setDataProvider(value, event) {
      if (event) {
        this.handleSelectedField(value, event)
      }
      let allCurrencyHasZeroSum = true
      this.dynamicChildren = []
      if (!value || value.length === 0) {
        this.numAll = 0
        this.numSelected = 0
        return
      }
      this.data = value
      const _dataProvider = this.data
      this.numAll = 0
      this.handleAllNum(event)
      if (this.numAll === 0) {
        this.numAll = this.data.length
      }
      this.numSelected = 0
      if (event) {
        this.numSelected = event.api.getSelectedRows().length
      }
      if (this.datafield && this.datafield !== '') {
        for (const c of this.currencyUsed) {
          c.sum = NaN
        }
        for (const d of _dataProvider) {
          // if (Number(d.isSelect)) { this.numSelected += 1 } // todo-shengsheng  Desc: 选中的判断
          for (const c of this.currencyUsed) {
            // if (((this.onSelect && Number(d.isSelect)) || !this.onSelect) && (this.arDataField === '' || (this.arDataField !== '' && d.hasOwnProperty(this.arDataField) && d[this.arDataField] === this.isAr))) {
            if (this.onSelect && (this.arDataField === '' || (this.arDataField !== '' && d.hasOwnProperty(this.arDataField) && d[this.arDataField] === this.isAr))) {
              if (this.isSimpleSum) {
                if (isNaN(c.sum)) {
                  if (d[this.datafield] !== 0) {
                    c.sum = d[this.datafield]
                  }
                } else {
                  c.sum += d[this.datafield]
                }
                break
              } else if (this.hasMutiCurrency && d.hasOwnProperty(this.datafield + c.currency)) {
                if (isNaN(c.sum)) {
                  if (d[this.datafield + c.currency] !== 0) {
                    c.sum = d[this.datafield + c.currency]
                  }
                } else {
                  c.sum += d[this.datafield + c.currency]
                }
              } else if (this.useCurrencyORI) {
                if (d.CURRENCY_ORI === c.currency) {
                  if (isNaN(c.sum)) {
                    c.sum = d[this.datafield]
                  } else {
                    c.sum += d[this.datafield]
                  }
                  break
                }
              } else if (d.currency === c.currency) {
                if (isNaN(c.sum)) {
                  c.sum = d[this.datafield]
                } else {
                  c.sum += d[this.datafield]
                }
                break
              }
            }
          }
        }
        for (const c of this.currencyUsed) {
          if (!isNaN(c.sum)) {
            this.addChildren(c)
            allCurrencyHasZeroSum = false
          }
        }

        if (allCurrencyHasZeroSum) {
          this.addChildrenForZeroSum()
        }
      }
    },

    addChildren(currency) {
      if (!this.isSimpleSum) { // 简单合计不添加币种标签
        const lbl = {}
        if (this.isInvoice) {
          if (currency != null && currency.currency != null && currency.currency !== 'RMB') {
            lbl.text = currency.currency + this.$t('CargoMsg.Cargo_ConversionRMB')
          } else {
            lbl.text = currency.currency
          }
        } else {
          lbl.text = currency.currency
        }
        lbl.height = 23
        lbl.type = 'label'
        lbl.style = ('text-align:right')
        this.dynamicChildren.push(lbl)
      }
      const ti = {}
      ti.text = currency.sum.toFixed(2)
      ti.type = 'input'
      ti.width = 80
      ti.height = 23
      ti.editable = false
      ti.style = ('text-align:right')
      this.dynamicChildren.push(ti)
    },
    addChildrenForZeroSum() {
      const lbl = {}
      lbl.text = '0'
      lbl.type = 'input'
      lbl.height = 23
      lbl.width = 30
      lbl.editable = false
      lbl.style = ('text-align:right')
      this.dynamicChildren.push(lbl)
    }
  }

}
</script>

<style lang="scss" scoped>
.input-div{
  border: 1px solid gainsboro;height: 25px;color:gray;text-align: right;padding-right: 1px;
}
.screen1366 {
  flex-wrap: nowrap !important;
  div, span {
    font-size: 10px !important;
    white-space: nowrap;
  }
}
</style>
